var render = function (_h,_vm) {var _c=_vm._c;return _c('button',_vm._g(_vm._b({class:[
		'btn',
		'btn-link',
		'claim-form-button',
		'py-1',
		'text-uppercase',
		_vm.data.staticClass ],attrs:{"type":"button"}},'button',_vm.data.attrs,false),_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }